import React from 'react';
import {connect} from "react-redux";
import SqftCanvas from "./SqftCanvas";

const SqftCanvasContainer = () => {
  // other popups, modals and so on

  return (
    <div id="sqft-main-grid" className="sqft-main-grid">
      <SqftCanvas options={{}}/>
      <div id="angle-tooltip" className="tooltip tooltip-angle">
        <div className="tooltip-angle-nav">
          <input type="number" className="ui-input tooltip-angle-nav-input" id="angle_input" min="0" max="180"/>
          <div data-action="angle-input-up" className="tooltip-angle-nav-arrow tooltip-angle-nav-arrow-up">
            <svg className="triangle">
              <path d="M 22 8 L 40 30 L 5 30 z" stroke="#ffffff" strokeLinejoin="round" strokeWidth="8px"/>
              <path d="M 22 13 L 35 30 L 9 30 z" fill="#4A90E2" stroke="#4A90E2" strokeLinejoin="round" strokeWidth="8px"/>
            </svg>
          </div>
          <div data-action="angle-input-down" className="tooltip-angle-nav-arrow tooltip-angle-nav-arrow-down">
            <svg className="triangle">
              <path d="M 22 8 L 40 30 L 5 30 z" stroke="#ffffff" strokeLinejoin="round" strokeWidth="8px"/>
              <path d="M 22 13 L 35 30 L 9 30 z" fill="#4A90E2" stroke="#4A90E2" strokeLinejoin="round" strokeWidth="8px"/>
            </svg>
          </div>
        </div>
        <button data-action="angle-input-submit"
                className="ui-button10 ui-button10--green tooltip-angle-btn"
                data-text="sqft.contextmenu.angleTooltipAccept">Accept</button>
      </div>
    </div>
  )
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftCanvasContainer);
